import React from 'react';
import Box from '@mui/material/Box';
import { OpenAPIV3_1 as OpenAPI } from "openapi-types";
import _ from 'lodash';
import SplitPane from '../SplitPane';
import ResponseBox from '../ResponseBox';
import RequestBox from '../RequestBox';
import { httpPut } from 'src/api';

export interface PutProps {
    operationObject: OpenAPI.OperationObject;
}

const Put: React.FC<PutProps> = ({ operationObject }) => {
    const { responses } = operationObject;

    return (
        <Box>
            <SplitPane
                req={
                    <RequestBox
                        operationObject={operationObject}
                        runRequest={
                            (pathKey, pathParams, queryParams, body) => httpPut(pathKey, pathParams, queryParams, body)
                        }
                    />
                }
                res={<ResponseBox responsesObject={responses} />}
            />
        </Box>
    );
};

export default Put;
